import React from 'react';
import { isEmpty, map } from 'lodash';
import translateService from '../../common/translateService';
import JSportAutocompleteResult from './JSportAutocompleteResult.jsx';
import './JSportAutocompleteResults.scss';

const JSportAutocompleteResultsCategory = ({ url, label }) => (
    <li key={url}>
        <a href={url}>{label}</a>
    </li>
);
const JSportAutocompleteResultsBrand = ({ url, label, image }) => (
    <div className='brand-block' key={url}>
        <a itemProp='url' href={url} title={label}>
            <img
                className='brand__image'
                itemProp='image'
                src={image}
                alt={label}
            />
        </a>
    </div>
);
const JSportAutocompleteResultsOtherItems = ({ count, url, type }) => (
    <a
        href={url}
        className='link'
        style={{
            fontWeight: 'bold',
            borderBottomColor: 'black',
            width: 'fit-content',
        }}>
        {translateService
            .interpolate(`search.plusOther` + type, {
                count: count,
            })
            .toUpperCase()}
    </a>
);

function JSportAutocompleteResults({
    inputValue,
    products,
    totalProducts,
    url,
    brands,
    otherBrands,
    categories,
    otherCategories,
    getMenuProps,
}) {
    const MINIMUM_CHARS_FOR_SEARCH = 3;

    const showAllResults = inputValue.length >= MINIMUM_CHARS_FOR_SEARCH;
    const someResultsFound =
        inputValue.length >= MINIMUM_CHARS_FOR_SEARCH && products.length > 0;
    return (
        <div {...getMenuProps({})} className={'jsport-autocomplete-results'}>
            {someResultsFound && (
                <div
                    className={
                        someResultsFound
                            ? 'container-with-results'
                            : 'container-with-no-results'
                    }>
                    <div className='sidebar'>
                        <div className='column'></div>

                        <div className='column-central'>
                            <div className='sidebar-block'>
                                <strong>
                                    {translateService
                                        .get('search.categories')
                                        .toUpperCase()}
                                </strong>
                                <ul className='list'>
                                    {map(categories, (category) => (
                                        <JSportAutocompleteResultsCategory
                                            key={category.label}
                                            url={category.url}
                                            label={category.label}
                                        />
                                    ))}
                                </ul>
                                {otherCategories > 0 && (
                                    <JSportAutocompleteResultsOtherItems
                                        count={otherCategories}
                                        url={url}
                                        type={'Categories'}
                                    />
                                )}
                            </div>
                            <div className='sidebar-block'>
                                <strong>
                                    {translateService
                                        .get('search.brands')
                                        .toUpperCase()}
                                </strong>
                                {map(brands, (brand) => (
                                    <JSportAutocompleteResultsBrand
                                        key={brand.label}
                                        url={brand.url}
                                        label={brand.label}
                                        image={brand.image}
                                    />
                                ))}
                                {otherBrands > 0 && (
                                    <JSportAutocompleteResultsOtherItems
                                        count={otherBrands}
                                        url={url}
                                        type={'Brands'}
                                    />
                                )}
                            </div>
                        </div>
                        <div className='column'></div>
                    </div>
                    <div className='products-container'>
                        <div className='products-container-items'>
                            {map(products, (product, idx) => (
                                <JSportAutocompleteResult
                                    key={idx}
                                    label={`${product.label}`}
                                    url={product.url}
                                    brand={product.brand}
                                    image={product.image}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {!someResultsFound && !isEmpty(inputValue) && (
                <div className='container-with-no-results'>
                    {translateService
                        .get('search.noResultsFound')
                        .toUpperCase()}
                </div>
            )}
            {showAllResults && (
                <div
                    className={
                        someResultsFound
                            ? 'jsport-autocomplete-all-results'
                            : 'jsport-autocomplete-all-results results-visible'
                    }>
                    <strong>
                        <a href={url}>
                            {translateService.get('search.moreResults')}
                        </a>
                    </strong>
                </div>
            )}
        </div>
    );
}

export default JSportAutocompleteResults;
